// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__jJpT3","link":"Button_link__F35bH","hyperlink":"Button_hyperlink__2kYag"};